import Serializable from './serializable';

export class Building extends Serializable {

	constructor(collectionPath) {
		super();
		this.collectionPath = collectionPath;
	}

	id: string;
	gameId: string;
	collectionPath: string;

	buildingType: string; //habitation, public_service, energy_production
	level: number = 1;
	orderNum: number;
	name: string;
	labels: {} = {};
	description: {} = {};

	dependencies: {} = {};

	neededResources: {} = {};
	givenResources: {} = {};

	co2Impact: number;
	populationImpact: number;
	buildActivateMissions = [];
	buildActivateObjects = [];
	buildCompleteMessage: {} = {};

	iconUrl: string;

	pictureUrl: string;
	filePath: string;
	pictureLastUpdate: number;
	picture: {} = {};
	pictureWidth: number;
	pictureHeight: number;

	getBuildingTypeStr(){
		switch(this.buildingType){
			case 'habitation':
				return 'Habitation';
			case 'public_service':
				return 'Public service';
			case 'energy_production':
				return 'Energy production';
		}
		return '';
	}
}
